// extracted by mini-css-extract-plugin
module.exports = {"boundary":"ErrorBoundary_boundary__2uu_S"};